import { useEffect, useState } from 'preact/hooks';
import { DEFAULT_DASHBOARD } from '@hud/core';

/**
 * Which dashboard is showing, from the hash: `#/tasks` → `tasks`.
 *
 * Hash routing rather than history routing because the production host is a
 * static CDN with no rewrite rules — `/tasks` would 404 on a hard refresh.
 */
export function useRoute(): string {
  const [name, setName] = useState(readHash);

  useEffect(() => {
    const onHashChange = () => setName(readHash());
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  return name;
}

function readHash(): string {
  const raw = window.location.hash.replace(/^#\/?/, '').trim();
  // Guard against a hash that would escape the dashboards directory.
  if (!raw || raw.includes('/') || raw.includes('..')) return DEFAULT_DASHBOARD;
  return raw;
}
